/* Lockett Labs Events: the promo kit, on the vendor dashboard.
   Posters drawn in the browser with the trader's own logo, their table, the
   show's details and artwork and a QR code to the show page:
     formats  square post 1080, story 1080 x 1920, landscape 1200 x 630,
              A4 print 2480 x 3508 (300 dpi)
     styles   Night, Ember, Paper (the brand's own colours, nothing else)
   plus an animated story recorded straight from the canvas (MP4 where the
   browser can, WebM otherwise), captions to copy, and sharing.
   Nothing is uploaded: the posters are made on this device. */
(function () {
  'use strict';

  // The short address printed on posters, and the one the QR code opens.
  // Cloudflare forwards it: events.lockett-labs.com/<show> to that show's
  // page (or to the hub, if the forward keeps no path).
  var EVENTS_HOST = 'events.lockett-labs.com';
  var EV = window.EV;
  if (!EV) return;
  var el = EV.el;
  var icon = EV.icon;

  var FORMATS = [
    { id: 'square', label: 'Square post', note: 'Instagram, Facebook', w: 1080, h: 1080 },
    { id: 'story', label: 'Story', note: 'Instagram, WhatsApp, TikTok', w: 1080, h: 1920 },
    { id: 'wide', label: 'Landscape', note: 'Facebook, X, links', w: 1200, h: 630 },
    { id: 'a4', label: 'A4 print', note: 'Print for your table', w: 2480, h: 3508 }
  ];
  var STYLES = [
    { id: 'night', label: 'Night', bg: '#0b0711', ink: '#ffffff', mute: 'rgba(255,248,242,.72)', kick: '#ffc94f', accent: '#ff6248', panel: 'rgba(255,255,255,.07)', line: 'rgba(255,255,255,.16)' },
    { id: 'ember', label: 'Ember', bg: '#ff6248', ink: '#ffffff', mute: 'rgba(255,255,255,.86)', kick: '#1e0803', accent: '#1e0803', panel: 'rgba(30,8,3,.16)', line: 'rgba(255,255,255,.4)' },
    { id: 'paper', label: 'Paper', bg: '#fff6ec', ink: '#1e0803', mute: 'rgba(30,8,3,.66)', kick: '#b23a22', accent: '#ff6248', panel: 'rgba(30,8,3,.06)', line: 'rgba(30,8,3,.16)' }
  ];

  /* ---------------------------------------------------------------- loading */
  function loadImage(src, cors) {
    return new Promise(function (resolve, reject) {
      if (!src) { reject(new Error('none')); return; }
      var im = new Image();
      if (cors) im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () { resolve(im); };
      im.onerror = function () { reject(new Error('load')); };
      im.src = src;
    });
  }
  /* A picture another site serves must allow being read back, or every
     download fails; test it once on a scrap of canvas. */
  function usable(im) {
    try { var c = document.createElement('canvas'); c.width = c.height = 2; var x = c.getContext('2d'); x.drawImage(im, 0, 0, 2, 2); x.getImageData(0, 0, 1, 1); return true; } catch (e) { return false; }
  }
  function art(urls) {
    var i = 0;
    return new Promise(function (resolve) {
      (function next() {
        if (i >= urls.length) { resolve(null); return; }
        loadImage(urls[i++], true).then(function (im) { if (usable(im)) resolve(im); else next(); }).catch(next);
      })();
    });
  }
  function displayFamily() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--ev-display-face') || '';
    var f = v.split(',')[0].trim().replace(/^["']|["']$/g, '');
    return f || 'Anton';
  }

  /* ---------------------------------------------------------------- drawing helpers */
  function rr(c, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    c.beginPath();
    c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r);
    c.closePath();
  }
  function nut(c, cx, cy, r, color) {
    c.save();
    c.beginPath();
    for (var i = 0; i < 6; i++) { var a = Math.PI / 3 * i; c[i ? 'lineTo' : 'moveTo'](cx + r * Math.cos(a), cy + r * Math.sin(a)); }
    c.closePath();
    c.moveTo(cx + r * 0.36, cy);
    c.arc(cx, cy, r * 0.36, 0, Math.PI * 2, true);
    c.fillStyle = color;
    c.fill('evenodd');
    c.restore();
  }
  function cover(c, im, x, y, w, h, zoom) {
    var s = Math.max(w / im.width, h / im.height) * (zoom || 1);
    var dw = im.width * s, dh = im.height * s;
    c.drawImage(im, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }
  function contain(c, im, x, y, w, h) {
    var s = Math.min(w / im.width, h / im.height);
    var dw = im.width * s, dh = im.height * s;
    c.drawImage(im, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }
  /* How a trader's logo wants to sit in its slot, judged from its edge pixels,
     so no logo ends up in a white frame it did not ask for:
       bleed  artwork or a photo out to the edges: fills the slot
       solid  a flat background colour: the slot takes that colour
       clear  a transparent background: a plain slot, white, or night for a light logo */
  function logoFit(im) {
    if (im.__fit) return im.__fit;
    var fitL = { mode: 'clear', bg: '#ffffff', dark: false };
    try {
      var n = 72;
      var w = Math.max(4, Math.round(im.width >= im.height ? n : n * im.width / im.height));
      var h = Math.max(4, Math.round(im.height >= im.width ? n : n * im.height / im.width));
      var cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      var x = cv.getContext('2d', { willReadFrequently: true });
      x.drawImage(im, 0, 0, w, h);
      var px = x.getImageData(0, 0, w, h).data;
      var edge = [], body = 0, lum = 0;
      for (var yy = 0; yy < h; yy++) {
        for (var xx = 0; xx < w; xx++) {
          var i = (yy * w + xx) * 4;
          if (xx < 2 || yy < 2 || xx >= w - 2 || yy >= h - 2) edge.push([px[i], px[i + 1], px[i + 2], px[i + 3]]);
          else if (px[i + 3] > 128) { body++; lum += (0.2126 * px[i] + 0.7152 * px[i + 1] + 0.0722 * px[i + 2]) / 255; }
        }
      }
      var clear = edge.filter(function (e) { return e[3] < 60; }).length / edge.length;
      if (clear > 0.4) {
        fitL.dark = !!body && lum / body > 0.72;
        fitL.bg = fitL.dark ? '#1a1022' : '#ffffff';
      } else {
        var m = [0, 0, 0];
        edge.forEach(function (e) { m[0] += e[0]; m[1] += e[1]; m[2] += e[2]; });
        m = m.map(function (v) { return v / edge.length; });
        var dev = 0;
        edge.forEach(function (e) { dev += Math.abs(e[0] - m[0]) + Math.abs(e[1] - m[1]) + Math.abs(e[2] - m[2]); });
        dev /= edge.length * 3;
        var ratio = im.width / im.height;
        fitL.bg = 'rgb(' + m.map(Math.round).join(',') + ')';
        fitL.dark = (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255 < 0.5;
        // a busy edge on a square logo is artwork: let it fill the slot; anything else sits on its own edge colour
        fitL.mode = dev >= 10 && ratio > 0.8 && ratio < 1.25 ? 'bleed' : 'solid';
      }
    } catch (e) { /* a logo that cannot be read: the plain white slot */ }
    im.__fit = fitL;
    return fitL;
  }
  /* Words broken into at most `lines` lines, the font shrunk until they fit. */
  function fit(c, text, maxW, size, min, family, weight, lines) {
    var words = String(text).split(/\s+/).filter(Boolean);
    for (var s = size; s >= min; s -= Math.max(1, Math.round(size * 0.04))) {
      c.font = weight + ' ' + s + 'px ' + family;
      var out = [], cur = '';
      var ok = true;
      for (var i = 0; i < words.length; i++) {
        var t = cur ? cur + ' ' + words[i] : words[i];
        if (c.measureText(t).width <= maxW) cur = t;
        else { if (cur) out.push(cur); cur = words[i]; if (c.measureText(cur).width > maxW) { ok = false; break; } }
      }
      if (cur) out.push(cur);
      if (ok && out.length <= lines) return { size: s, lines: out };
    }
    c.font = weight + ' ' + min + 'px ' + family;
    return { size: min, lines: [String(text)] };
  }
  /* One line no wider than maxW at the current font: cut with an ellipsis when it has to be. */
  function clip(c, text, maxW) {
    var t = String(text);
    if (c.measureText(t).width <= maxW) return t;
    while (t.length > 1 && c.measureText(t + '…').width > maxW) t = t.slice(0, -1);
    return t.replace(/\s+$/, '') + '…';
  }
  function spaced(c, text, x, y, spacing, align) {
    // letter-spacing, drawn a character at a time (canvas letterSpacing is not everywhere yet)
    var chars = String(text).split('');
    var w = chars.reduce(function (a, ch) { return a + c.measureText(ch).width + spacing; }, -spacing);
    var sx = align === 'right' ? x - w : align === 'center' ? x - w / 2 : x;
    var al = c.textAlign;
    c.textAlign = 'left';
    chars.forEach(function (ch) { c.fillText(ch, sx, y); sx += c.measureText(ch).width + spacing; });
    c.textAlign = al;
    return w;
  }
  function chip(c, text, x, y, h, bg, fg, font, padX) {
    c.font = font;
    var w = c.measureText(text).width + padX * 2;
    c.fillStyle = bg;
    rr(c, x, y, w, h, h / 2);
    c.fill();
    c.fillStyle = fg;
    c.textBaseline = 'middle';
    c.fillText(text, x + padX, y + h / 2 + 1);
    c.textBaseline = 'alphabetic';
    return w;
  }
  var ease = {
    out: function (t) { return 1 - Math.pow(1 - t, 3); },
    back: function (t) { var s = 1.6; t -= 1; return t * t * ((s + 1) * t + s) + 1; }
  };
  function span(t, a, b) { return t == null ? 1 : Math.max(0, Math.min(1, (t - a) / (b - a))); }

  /* ---------------------------------------------------------------- the poster */
  /*
    d: { W, H, fmt, style, art, logo, family, title, business, initials,
         kicker, date, time, venue, table, tier, url, tags, showQr }
    t: seconds into the animation, or null for the finished poster.
  */
  function draw(c, d, t) {
    var W = d.W, H = d.H, S = Math.min(W, H) / 1080, st = d.style, F = d.family;
    var wide = d.fmt === 'wide';
    var pad = Math.round((wide ? 52 : 64) * S);
    c.save();
    c.clearRect(0, 0, W, H);
    c.textBaseline = 'alphabetic';

    // background
    c.fillStyle = st.bg;
    c.fillRect(0, 0, W, H);
    if (st.id === 'ember') {
      var eg = c.createLinearGradient(0, 0, W * 0.4, H);
      eg.addColorStop(0, '#ff7a5e'); eg.addColorStop(1, '#d9432a');
      c.fillStyle = eg; c.fillRect(0, 0, W, H);
    }
    var zoom = t == null ? 1 : 1.12 - 0.12 * ease.out(span(t, 0, 1.2)) + (t > 3.6 ? (t - 3.6) * 0.012 : 0);
    var artA = t == null ? 1 : ease.out(span(t, 0, 0.9));
    if (d.art) {
      c.save();
      c.globalAlpha = (st.id === 'night' ? 0.62 : st.id === 'ember' ? 0.2 : 1) * artA;
      if (st.id === 'paper' && wide) {
        // landscape on paper: the art as a faint texture behind everything
        c.globalAlpha = 0.1 * artA;
        cover(c, d.art, 0, 0, W, H, zoom);
      } else if (st.id === 'paper') {
        // portrait on paper: the art as a band across the top, fading to cream
        var ah = Math.round(H * (d.fmt === 'square' ? 0.34 : 0.32));
        c.beginPath(); c.rect(0, 0, W, ah); c.clip();
        cover(c, d.art, 0, 0, W, ah, zoom);
        var pg = c.createLinearGradient(0, ah * 0.35, 0, ah);
        pg.addColorStop(0, 'rgba(255,246,236,0)'); pg.addColorStop(1, st.bg);
        c.globalAlpha = 1; c.fillStyle = pg; c.fillRect(0, 0, W, ah);
      } else {
        if (st.id === 'ember') c.globalCompositeOperation = 'multiply';
        cover(c, d.art, 0, 0, W, H, zoom);
      }
      c.restore();
    }
    if (st.id === 'night') {
      var g = c.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, 'rgba(11,7,17,.55)'); g.addColorStop(0.45, 'rgba(11,7,17,.78)'); g.addColorStop(1, 'rgba(11,7,17,.96)');
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      var rg = c.createRadialGradient(W * 0.1, H * 0.02, 0, W * 0.1, H * 0.02, W * 0.9);
      rg.addColorStop(0, 'rgba(255,98,72,.32)'); rg.addColorStop(1, 'rgba(255,98,72,0)');
      c.fillStyle = rg; c.fillRect(0, 0, W, H);
    }
    // the ember sweep in the animated story: a slow pass of light
    if (t != null && t > 3.4) {
      var sx = (span(t, 3.4, 6.2)) * (W + H) - H * 0.5;
      var sg = c.createLinearGradient(sx - W * 0.3, 0, sx + W * 0.3, H * 0.4);
      sg.addColorStop(0, 'rgba(255,201,79,0)'); sg.addColorStop(0.5, st.id === 'paper' ? 'rgba(255,98,72,.08)' : 'rgba(255,201,79,.12)'); sg.addColorStop(1, 'rgba(255,201,79,0)');
      c.fillStyle = sg; c.fillRect(0, 0, W, H);
    }

    // frame
    c.strokeStyle = st.line;
    c.lineWidth = Math.max(2, 3 * S);
    rr(c, pad / 2, pad / 2, W - pad, H - pad, 28 * S);
    c.stroke();

    // top bar: the nut and the wordmark, the date on the right
    var tb = t == null ? 1 : ease.out(span(t, 0.3, 1.1));
    c.save();
    c.globalAlpha = tb;
    c.translate(0, (1 - tb) * -40 * S);
    var ty = pad + 30 * S;
    nut(c, pad + 22 * S, ty, 22 * S, st.accent === '#1e0803' ? '#1e0803' : '#ff6248');
    c.fillStyle = st.ink;
    c.font = '400 ' + Math.round(30 * S) + 'px ' + F;
    spaced(c, 'LOCKETT LABS EVENTS', pad + 58 * S, ty + 11 * S, 2.4 * S);
    if (d.tier) {
      c.font = '800 ' + Math.round(20 * S) + 'px Inter, system-ui, sans-serif';
      var tw = c.measureText(d.tier.toUpperCase()).width + 44 * S;
      chip(c, d.tier.toUpperCase(), W - pad - tw, ty - 21 * S, 42 * S, st.id === 'ember' ? '#1e0803' : '#ff6248', '#ffffff', '800 ' + Math.round(20 * S) + 'px Inter, system-ui, sans-serif', 22 * S);
    }
    c.restore();

    // where the words and the logo go
    var lay = wide
      ? { plate: Math.round(H * 0.44), px: pad + 24 * S, py: Math.round(H * 0.24), tx: pad + 24 * S + Math.round(H * 0.44) + 44 * S, ty: Math.round(H * 0.26), tw: W - (pad + 24 * S + Math.round(H * 0.44) + 44 * S) - pad - 20 * S, title: 96, lines: 2 }
      : d.fmt === 'story'
        ? { plate: Math.round(W * 0.36), px: pad + 30 * S, py: Math.round(H * 0.21), tx: pad + 30 * S, ty: Math.round(H * 0.21) + Math.round(W * 0.36) + 70 * S, tw: W - 2 * pad - 60 * S, title: 168, lines: 3 }
        : d.fmt === 'a4'
          ? { plate: Math.round(W * 0.3), px: pad + 30 * S, py: Math.round(H * 0.2), tx: pad + 30 * S, ty: Math.round(H * 0.2) + Math.round(W * 0.3) + 64 * S, tw: W - 2 * pad - 60 * S, title: 150, lines: 3 }
          : { plate: Math.round(W * 0.25), px: pad + 30 * S, py: Math.round(H * 0.16), tx: pad + 30 * S, ty: Math.round(H * 0.16) + Math.round(W * 0.25) + 56 * S, tw: W - 2 * pad - 60 * S, title: 118, lines: 2 };
    // a story has room to sit the block a little lower, clear of the top bar and Instagram's own header
    if (d.fmt === 'story') { lay.py = Math.round(H * 0.25); lay.ty = lay.py + lay.plate + 70 * S; }

    // The footer's top (QR code, address, hashtags): nothing above may cross it.
    var qs = d.showQr ? Math.round((wide ? 150 : d.fmt === 'story' ? 210 : 190) * S) : 0;
    var fy = H - pad - Math.max(qs, 90 * S) - 10 * S;
    // a clear band above it, so the chips never crowd the QR code
    var limit = fy - Math.round(34 * S);
    // Fit the whole stack (logo, kicker, title, "with", the first row of
    // chips) above that line before anything is drawn. A long show name or
    // business gives way first in the title's size, then the logo's, then the
    // gaps, so the poster never draws words over each other.
    var chipH = Math.round((wide ? 50 : 60) * S);
    var TITLE = String(d.title).toUpperCase();
    var gapPT = wide ? 0 : lay.ty - lay.py - lay.plate;
    var plate0 = lay.plate;
    var titleMax = Math.round(lay.title * S), titleMin = Math.round(lay.title * 0.42 * S);
    var busMax = Math.round((wide ? 38 : 46) * S), busMin = Math.round(24 * S);
    var ft, fb;
    var stackH = function () {
      ft = fit(c, TITLE, lay.tw, titleMax, titleMin, F, '400', lay.lines);
      fb = fit(c, 'with ' + d.business, lay.tw, busMax, busMin, 'Inter, system-ui, sans-serif', '800', 1);
      fb.lines = [clip(c, fb.lines[0], lay.tw)];
      return Math.round(18 * S) + ft.lines.length * ft.size * 0.98 + Math.round(22 * S) + fb.size + Math.round((wide ? 30 : 42) * S) + chipH;
    };
    var bottomOf = function (h) { return wide ? Math.max(lay.ty + h, lay.py + lay.plate) : lay.py + lay.plate + gapPT + h; };
    var th = stackH();
    for (var guard = 0; bottomOf(th) > limit && guard < 60; guard++) {
      if (titleMax > lay.title * 0.6 * S) titleMax = Math.round(titleMax * 0.95);
      else if (!wide && lay.plate > plate0 * 0.6) lay.plate = Math.round(lay.plate * 0.95);
      else if (gapPT > 26 * S) gapPT = Math.round(gapPT * 0.85);
      else if (busMax > 30 * S) busMax = Math.round(busMax * 0.94);
      else if (titleMax > titleMin) titleMax = Math.max(titleMin, Math.round(titleMax * 0.95));
      else break;
      th = stackH();
    }
    if (!wide) lay.ty = lay.py + lay.plate + gapPT;

    // the logo on its plate
    var lp = t == null ? 1 : ease.back(span(t, 0.8, 1.6));
    c.save();
    var pcx = lay.px + lay.plate / 2, pcy = lay.py + lay.plate / 2;
    c.translate(pcx, pcy);
    c.scale(0.6 + 0.4 * lp, 0.6 + 0.4 * lp);
    c.rotate((1 - lp) * -0.12);
    c.globalAlpha = Math.min(1, span(t, 0.8, 1.1));
    c.shadowColor = 'rgba(0,0,0,.45)'; c.shadowBlur = 50 * S; c.shadowOffsetY = 22 * S;
    var P = lay.plate, lf = d.logo ? logoFit(d.logo) : null;
    c.fillStyle = lf ? lf.bg : '#ffffff';
    rr(c, -P / 2, -P / 2, P, P, P * 0.2);
    c.fill();
    c.shadowColor = 'transparent';
    c.save();
    rr(c, -P / 2, -P / 2, P, P, P * 0.2);
    c.clip();
    if (d.logo) {
      if (lf.mode === 'bleed') cover(c, d.logo, -P / 2, -P / 2, P, P);
      else {
        var ins = lf.mode === 'solid' ? 0.06 : 0.1;
        contain(c, d.logo, -P / 2 + P * ins, -P / 2 + P * ins, P * (1 - 2 * ins), P * (1 - 2 * ins));
      }
    } else {
      c.fillStyle = '#fff6ec'; c.fillRect(-lay.plate / 2, -lay.plate / 2, lay.plate, lay.plate);
      c.fillStyle = '#1e0803'; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.font = '900 ' + Math.round(lay.plate * 0.36) + 'px Inter, system-ui, sans-serif';
      c.fillText(d.initials, 0, 0);
      c.textAlign = 'left'; c.textBaseline = 'alphabetic';
    }
    c.restore();
    // ember corner tab on the plate, clipped to its rounded corner
    c.save();
    rr(c, -lay.plate / 2, -lay.plate / 2, lay.plate, lay.plate, lay.plate * 0.2);
    c.clip();
    c.fillStyle = '#ff6248';
    c.beginPath(); c.moveTo(lay.plate / 2 - lay.plate * 0.2, -lay.plate / 2); c.lineTo(lay.plate / 2, -lay.plate / 2); c.lineTo(lay.plate / 2, -lay.plate / 2 + lay.plate * 0.2); c.closePath();
    c.fill();
    c.restore();
    // a dark slot gets a hairline so it still reads as a tile on the night poster
    if (lf && lf.dark) {
      c.strokeStyle = 'rgba(255,255,255,.18)'; c.lineWidth = 2 * S;
      rr(c, -P / 2 + S, -P / 2 + S, P - 2 * S, P - 2 * S, P * 0.2 - S);
      c.stroke();
    }
    c.restore();

    // the words
    var y = lay.ty;
    var k = t == null ? 1 : ease.out(span(t, 1.3, 1.9));
    c.save();
    c.globalAlpha = k;
    c.fillStyle = st.kick;
    c.font = '800 ' + Math.round((wide ? 26 : 30) * S) + 'px Inter, system-ui, sans-serif';
    spaced(c, String(d.kicker).toUpperCase(), lay.tx + (1 - k) * -30 * S, y, 6 * S);
    c.restore();
    y += Math.round(18 * S);
    c.fillStyle = st.ink;
    ft.lines.forEach(function (ln, i) {
      var lt = t == null ? 1 : ease.out(span(t, 1.5 + i * 0.15, 2.2 + i * 0.15));
      y += ft.size * 0.98;
      c.save();
      c.globalAlpha = lt;
      c.font = '400 ' + ft.size + 'px ' + F;
      c.fillText(ln, lay.tx, y + (1 - lt) * 40 * S);
      c.restore();
    });
    y += Math.round(22 * S);
    var bz = t == null ? 1 : ease.out(span(t, 2.0, 2.6));
    c.save();
    c.globalAlpha = bz;
    c.fillStyle = st.mute;
    c.font = '800 ' + fb.size + 'px Inter, system-ui, sans-serif';
    y += fb.size;
    c.fillText(fb.lines[0], lay.tx, y);
    c.restore();

    // the details, as chips
    y += Math.round((wide ? 30 : 42) * S);
    var cx = lay.tx, gap = Math.round(12 * S);
    var chipFont = '800 ' + Math.round((wide ? 21 : 25) * S) + 'px Inter, system-ui, sans-serif';
    var items = [];
    if (d.date) items.push([d.date.toUpperCase(), st.id === 'paper' ? '#1e0803' : '#ffffff', st.id === 'paper' ? '#ffffff' : '#1e0803']);
    if (d.table) items.push(['TABLE ' + d.table.toUpperCase(), st.id === 'ember' ? '#1e0803' : '#ff6248', '#ffffff']);
    if (d.time) items.push([d.time, st.panel, st.ink]);
    items.forEach(function (it, i) {
      var p = t == null ? 1 : ease.back(span(t, 2.4 + i * 0.12, 2.9 + i * 0.12));
      if (p <= 0) return;
      // the last guard: a chip that would reach the footer is left out
      if (y + chipH > limit) return;
      c.save();
      c.globalAlpha = Math.min(1, p);
      c.font = chipFont;
      var w = c.measureText(it[0]).width + 2 * Math.round(24 * S);
      if (cx + w > lay.tx + lay.tw && cx > lay.tx) {
        // a second row only when there is room for it above the footer
        if (y + 2 * chipH + gap > limit) { c.restore(); return; }
        cx = lay.tx; y += chipH + gap;
      }
      c.translate(cx + w / 2, y + chipH / 2);
      c.scale(0.7 + 0.3 * p, 0.7 + 0.3 * p);
      chip(c, it[0], -w / 2, -chipH / 2, chipH, it[1], it[2], chipFont, Math.round(24 * S));
      c.restore();
      cx += w + gap;
    });
    var stackEnd = y + chipH;
    var fvz = d.venue ? fit(c, d.venue, lay.tw, Math.round((wide ? 26 : 32) * S), Math.round(18 * S), 'Inter, system-ui, sans-serif', '600', 1) : null;
    if (fvz && y + chipH + Math.round(26 * S) + fvz.size * 0.5 <= limit) {
      y += chipH + Math.round(26 * S);
      var vz = t == null ? 1 : ease.out(span(t, 2.8, 3.3));
      c.save();
      c.globalAlpha = vz;
      c.fillStyle = st.mute;
      c.font = '600 ' + fvz.size + 'px Inter, system-ui, sans-serif';
      c.fillText(fvz.lines[0], lay.tx, y + fvz.size * 0.4);
      c.restore();
      stackEnd = y + fvz.size * 0.5;
    }

    // footer: the QR code, the address, the hashtags
    var fz = t == null ? 1 : ease.out(span(t, 3.0, 3.8));
    c.save();
    c.globalAlpha = fz;
    c.translate(0, (1 - fz) * 30 * S);
    if (qs) {
      c.fillStyle = '#ffffff';
      rr(c, pad + 24 * S, fy, qs, qs, 18 * S);
      c.fill();
      EV.qrDraw(c, d.url, pad + 24 * S + 10 * S, fy + 10 * S, qs - 20 * S, { bg: false, quiet: 0, fg: '#0b0711' });
    }
    var fx = pad + 24 * S + (qs ? qs + 28 * S : 0);
    c.fillStyle = st.kick;
    c.font = '800 ' + Math.round(20 * S) + 'px Inter, system-ui, sans-serif';
    spaced(c, qs ? 'SCAN FOR TICKETS' : 'TICKETS', fx, fy + 30 * S, 3 * S);
    c.fillStyle = st.ink;
    c.font = '400 ' + Math.round((wide ? 40 : 46) * S) + 'px ' + F;
    c.fillText(String(d.site).toUpperCase(), fx, fy + 30 * S + 50 * S);
    if (d.tags) {
      c.fillStyle = st.mute;
      var fh = fit(c, d.tags, W - fx - pad - 24 * S, Math.round(24 * S), Math.round(16 * S), 'Inter, system-ui, sans-serif', '700', 2);
      c.font = '700 ' + fh.size + 'px Inter, system-ui, sans-serif';
      fh.lines.forEach(function (ln, i) { c.fillText(ln, fx, fy + 30 * S + 92 * S + i * fh.size * 1.3); });
    }
    c.restore();
    c.restore();
    // where the stack ended and the footer began, for the layout checks
    return { stackEnd: Math.round(stackEnd), limit: Math.round(limit), plate: lay.plate, title: ft.size, titleLines: ft.lines.length };
  }

  /* ---------------------------------------------------------------- the studio */
  function mount(box, ctx) {
    var a = ctx.app, ev = a.event || {}, sh = ctx.show || {}, kit = a.kit || {};
    var family = displayFamily();
    var handle = ev.handle || '';
    var pageUrl = kit.pageUrl || sh.url || ctx.shop + '/pages/events';
    function link(medium) {
      try {
        var u = new URL(pageUrl);
        u.searchParams.set('utm_source', 'trader');
        u.searchParams.set('utm_medium', medium);
        u.searchParams.set('utm_campaign', handle || 'events');
        u.searchParams.set('utm_content', a.ref);
        return u.toString();
      } catch (e) { return pageUrl; }
    }
    // This trader's short link: events.lockett-labs.com/<show>/<the end of
    // their reference>, which the short-link worker credits to them.
    var code = String(a.ref || '').split('-').pop();
    var traderLink = EV.SHORT && handle && /^[A-Za-z0-9]{4,10}$/.test(code) ? EV.SHORT + '/' + handle + '/' + code : '';
    // the poster's QR code: the short link, marked as a poster (or an A4 print)
    function qrLink(medium) {
      if (traderLink) return traderLink + '?s=' + (medium === 'print' ? 'a4' : 'p');
      var u = new URL('https://' + EVENTS_HOST + '/' + (handle ? encodeURIComponent(handle) : ''));
      u.searchParams.set('utm_source', 'trader');
      u.searchParams.set('utm_medium', medium);
      u.searchParams.set('utm_campaign', handle || 'events');
      u.searchParams.set('utm_content', a.ref);
      return u.toString();
    }
    var start = ev.startsAt ? new Date(ev.startsAt) : null;
    var end = ev.endsAt ? new Date(ev.endsAt) : null;
    var hm = function (d) { return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }); };
    var state = { fmt: 'square', style: 'night', table: true, qr: true };
    var D = {
      family: family, title: ev.title || 'Lockett Labs Events', business: a.business.name, initials: (a.business.name || '?').replace(/[^A-Za-z0-9 ]/g, '').split(/\s+/).map(function (w) { return w[0]; }).join('').slice(0, 2).toUpperCase() || '?',
      kicker: kit.headline || "I'm trading at",
      date: start ? start.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) : '',
      time: start ? 'Doors ' + hm(start) + (end ? ' to ' + hm(end) : '') : '',
      venue: [ev.venue, ev.town].filter(Boolean).join(', '),
      tier: a.tier ? a.tier.name : '',
      site: EVENTS_HOST,
      tags: kit.hashtags || '#LockettLabs #TCG'
    };
    var tableNo = a.booking && a.booking.tableNo ? a.booking.tableNo : '';

    // the page
    var canvas = el('canvas', { class: 'evk-canvas', role: 'img', 'aria-label': 'Your poster' });
    var busy = el('div', { class: 'evk-busy' }, el('span', { class: 'evx-skel' }), el('b', { text: 'Drawing your poster' }));
    var stage = el('div', { class: 'evk-stage is-square' }, canvas, busy);
    var fmtRow = el('div', { class: 'evk-seg', role: 'radiogroup', 'aria-label': 'Format' });
    FORMATS.forEach(function (f) {
      var b = el('button', { type: 'button', role: 'radio', class: 'evk-seg__b', 'data-v': f.id, 'aria-checked': state.fmt === f.id ? 'true' : 'false' },
        el('i', { class: 'evk-shape is-' + f.id }), el('span', null, el('b', { text: f.label }), el('small', { text: f.note })));
      b.addEventListener('click', function () { state.fmt = f.id; if (f.id === 'wide') state.qr = state.qr; paint(); });
      fmtRow.append(b);
    });
    var styleRow = el('div', { class: 'evk-styles', role: 'radiogroup', 'aria-label': 'Style' });
    STYLES.forEach(function (s) {
      var b = el('button', { type: 'button', role: 'radio', class: 'evk-style is-' + s.id, 'data-v': s.id, 'aria-checked': state.style === s.id ? 'true' : 'false' }, el('i'), el('span', { text: s.label }));
      b.addEventListener('click', function () { state.style = s.id; paint(); });
      styleRow.append(b);
    });
    var optTable = el('input', { type: 'checkbox' });
    optTable.checked = !!tableNo;
    optTable.disabled = !tableNo;
    optTable.addEventListener('change', function () { state.table = optTable.checked; paint(); });
    var optQr = el('input', { type: 'checkbox' });
    optQr.checked = true;
    optQr.addEventListener('change', function () { state.qr = optQr.checked; paint(); });
    var dlBtn = el('button', { type: 'button', class: 'ev-btn ev-btn--primary ev-btn--block' }, icon('down'), 'Download PNG');
    var shareBtn = el('button', { type: 'button', class: 'ev-btn ev-btn--block' }, icon('share'), 'Share the poster');
    var vidBtn = el('button', { type: 'button', class: 'ev-btn ev-btn--block evk-vid' }, icon('play'), 'Animated story (video)');
    var status = el('p', { class: 'evk-status', 'aria-live': 'polite' });
    var canFiles = false;
    try { canFiles = !!(navigator.canShare && navigator.canShare({ files: [new File([new Blob(['x'], { type: 'image/png' })], 'x.png', { type: 'image/png' })] })); } catch (e) { canFiles = false; }
    if (!canFiles) shareBtn.hidden = true;
    var canRecord = !!(window.MediaRecorder && HTMLCanvasElement.prototype.captureStream);
    if (!canRecord) vidBtn.hidden = true;

    box.append(el('section', { class: 'evk' },
      el('header', { class: 'evk-head' },
        el('div', null, el('span', { class: 'ev-kicker', text: 'Promo kit' }), el('h2', { class: 'ev-display', text: 'Posters with your logo' }),
          el('p', { text: 'Made on this device with your logo' + (tableNo ? ', your table number' : '') + ' and the show\'s details, with a QR code to the tickets. Pick a size and a style, then download or share.' }))),
      el('div', { class: 'evk-studio' },
        stage,
        el('div', { class: 'evk-ctrl' },
          el('div', { class: 'evk-grp' }, el('span', { class: 'evk-lab', text: 'Size' }), fmtRow),
          el('div', { class: 'evk-grp' }, el('span', { class: 'evk-lab', text: 'Style' }), styleRow),
          el('div', { class: 'evk-grp evk-opts' },
            el('label', { class: 'evf-tick' }, optTable, el('span', { text: tableNo ? 'Show my table number (' + tableNo + ')' : 'Table number (not allocated yet)' })),
            el('label', { class: 'evf-tick' }, optQr, el('span', { text: 'QR code to the tickets' }))),
          el('div', { class: 'evk-acts' }, dlBtn, shareBtn, vidBtn, status)))));

    // captions
    var tagLine = D.tags;
    // "graded cards and Pokémon singles": common words go lower case mid-sentence, game names keep their capitals
    var PROPER = /^(Pok[eé]mon|One Piece|Disney|Lorcana|Magic|Japanese|Digimon|Yu-Gi-Oh|Star Wars|Flesh and Blood|Dragon Ball|Union Arena|Weiss)/i;
    var cats = (a.categories || []).filter(function (c) { return !/^other$/i.test(c); }).slice(0, 2)
      .map(function (c) { return PROPER.test(c) ? c : c.charAt(0).toLowerCase() + c.slice(1); }).join(' and ');
    var days = start ? Math.max(0, Math.round((new Date(start).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0)) / 86400000)) : null;
    var social = traderLink || link('social');
    var caps = [
      ['Short and sweet', "We're trading at " + D.title + (D.date ? ' on ' + D.date : '') + '! ' + (tableNo ? 'Find us at table ' + tableNo + '. ' : '') + 'Come and say hi.\n\nTickets: ' + social + '\n\n' + tagLine],
      ['The full story', a.business.name + ' has a table at ' + D.title + (D.date ? ', ' + D.date : '') + (D.venue ? ' at ' + D.venue : '') + '. ' + (cats ? "We'll be bringing " + cats + ', and the chase cards you have been after. ' : '') + 'Bring your want list.\n\nTickets and every trader: ' + social + '\n\n' + tagLine],
      ['Countdown', (days != null && days > 0 ? days + (days === 1 ? ' day' : ' days') + ' until ' : 'Next stop: ') + D.title + '. ' + (tableNo ? 'Table ' + tableNo + ', ' : '') + 'see you there.\n\n' + social + '\n\n' + tagLine]
    ];
    var capBox = el('div', { class: 'evk-caps' });
    caps.forEach(function (cp) {
      var copy = el('button', { type: 'button', class: 'evx-chipbtn' }, icon('copy'), 'Copy');
      copy.addEventListener('click', function () { EV.copyText(cp[1], 'Caption copied'); ctx.track('share'); });
      capBox.append(el('article', { class: 'evk-cap' }, el('div', { class: 'evk-cap__h' }, el('b', { text: cp[0] }), copy), el('p', { text: cp[1] })));
    });
    var shareListing = el('button', { type: 'button', class: 'ev-btn' }, icon('share'), 'Share the show page');
    shareListing.addEventListener('click', function () {
      EV.share({ url: pageUrl, short: traderLink, title: D.title, text: caps[0][1].split('\n\n')[0], sub: D.date, hashtags: D.tags, campaign: handle, heading: 'Tell your followers', kicker: 'Share', onShare: function () { ctx.track('share'); } });
    });
    box.append(el('section', { class: 'evd-card evk-captions' }, el('h2', { class: 'evd-card__h' }, icon('chat'), 'Captions to post with them'), capBox, el('div', { class: 'ev-cta-row' }, shareListing)));

    // drawing
    var assets = { art: null, logo: null };
    var ready = Promise.all([
      art([sh.banner, ctx.wall].filter(Boolean)).then(function (im) { assets.art = im; }),
      ctx.loadLogo().then(function (src) { return src ? loadImage(src, false).then(function (im) { assets.logo = im; }) : null; }).catch(function () { /* initials instead */ }),
      document.fonts && document.fonts.load ? Promise.all([document.fonts.load('400 100px "' + family + '"'), document.fonts.load('800 40px Inter')]).catch(function () {}) : Promise.resolve()
    ]);
    function data(scale) {
      var f = FORMATS.filter(function (x) { return x.id === state.fmt; })[0];
      var s = STYLES.filter(function (x) { return x.id === state.style; })[0];
      return Object.assign({}, D, { W: Math.round(f.w * scale), H: Math.round(f.h * scale), fmt: f.id, style: s, art: assets.art, logo: assets.logo, table: state.table && tableNo ? tableNo : '', showQr: state.qr, url: qrLink(state.fmt === 'a4' ? 'print' : 'poster') });
    }
    function paint() {
      fmtRow.querySelectorAll('[data-v]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-v') === state.fmt ? 'true' : 'false'); });
      styleRow.querySelectorAll('[data-v]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-v') === state.style ? 'true' : 'false'); });
      stage.className = 'evk-stage is-' + state.fmt;
      var f = FORMATS.filter(function (x) { return x.id === state.fmt; })[0];
      var scale = Math.min(1, 1080 / Math.max(f.w, f.h)) * Math.min(2, window.devicePixelRatio || 1) / 1.4;
      scale = Math.min(scale, 1);
      var d = data(scale);
      canvas.width = d.W;
      canvas.height = d.H;
      draw(canvas.getContext('2d'), d, null);
    }
    function render(cb) {
      var d = data(1);
      var cv = document.createElement('canvas');
      cv.width = d.W; cv.height = d.H;
      draw(cv.getContext('2d'), d, null);
      cv.toBlob(function (b) { cb(b); }, 'image/png');
    }
    function fname(ext) {
      return (a.business.name + '-' + (D.title || 'show') + '-' + state.fmt).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.' + ext;
    }
    ready.then(function () { busy.hidden = true; paint(); });
    dlBtn.addEventListener('click', function () {
      dlBtn.classList.add('is-busy');
      ready.then(function () {
        render(function (b) {
          dlBtn.classList.remove('is-busy');
          if (!b) { EV.toast('Could not draw that one. Try another style.'); return; }
          EV.save(b, fname('png'));
          EV.toast('Poster saved');
          ctx.track('kit');
        });
      });
    });
    shareBtn.addEventListener('click', function () {
      ready.then(function () {
        render(function (b) {
          if (!b) return;
          var file = new File([b], fname('png'), { type: 'image/png' });
          navigator.share({ files: [file], text: caps[0][1] }).then(function () { ctx.track('share'); ctx.track('kit'); }).catch(function () { /* cancelled */ });
        });
      });
    });

    // the animated story: drawn frame by frame and recorded from the canvas
    vidBtn.addEventListener('click', function () {
      if (vidBtn.disabled) return;
      var types = ['video/mp4;codecs=avc1.42E01E', 'video/mp4', 'video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'];
      var type = types.filter(function (x) { try { return MediaRecorder.isTypeSupported(x); } catch (e) { return false; } })[0];
      if (!type) { EV.toast('This browser cannot record video. Try Chrome or Safari.'); return; }
      vidBtn.disabled = true;
      vidBtn.classList.add('is-busy');
      ready.then(function () {
        var keepFmt = state.fmt;
        state.fmt = 'story';
        var d = data(1);
        state.fmt = keepFmt;
        var cv = document.createElement('canvas');
        cv.width = d.W; cv.height = d.H;
        var c2 = cv.getContext('2d');
        draw(c2, d, 0);
        var stream = cv.captureStream(30);
        var rec;
        try { rec = new MediaRecorder(stream, { mimeType: type, videoBitsPerSecond: 8000000 }); } catch (e) { rec = new MediaRecorder(stream); }
        var chunks = [];
        rec.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
        rec.onstop = function () {
          vidBtn.disabled = false;
          vidBtn.classList.remove('is-busy');
          status.textContent = '';
          var blob = new Blob(chunks, { type: type.split(';')[0] });
          if (!blob.size) { EV.toast('The recording came out empty. Please try again.'); return; }
          EV.save(blob, fname(/mp4/.test(type) ? 'mp4' : 'webm').replace('-' + keepFmt + '.', '-story.'));
          EV.toast('Animated story saved');
          ctx.track('kit');
        };
        var LEN = 6.5;
        var t0 = performance.now();
        rec.start(250);
        // the live preview follows the recording, so they can watch it being made
        stage.className = 'evk-stage is-story';
        canvas.width = Math.round(d.W / 2); canvas.height = Math.round(d.H / 2);
        var pc = canvas.getContext('2d');
        (function frame(now) {
          var tt = (now - t0) / 1000;
          draw(c2, d, Math.min(tt, LEN));
          pc.drawImage(cv, 0, 0, canvas.width, canvas.height);
          status.textContent = 'Recording ' + Math.min(100, Math.round(tt / LEN * 100)) + '%';
          if (tt < LEN) requestAnimationFrame(frame);
          else setTimeout(function () { rec.stop(); stream.getTracks().forEach(function (tr) { tr.stop(); }); paint(); }, 120);
        })(t0);
      });
    });
  }

  window.EVKit = { mount: mount, draw: draw, FORMATS: FORMATS, STYLES: STYLES };
})();
